import { OperationContext } from '../types';
import { validateMetaStructure } from '../../utils/propertyPanel.ts';
import { collectRelatedFields } from './utils';

export const createVisibilityHandler = (context: OperationContext) => {
  const { meta, onChange } = context;

  return (itemName: string) => {
    try {
      // 1. 收集相关字段
      const relatedFields = collectRelatedFields(meta, itemName);

      // 2. 更新字段可见性
      const newMeta = {
        ...meta,
        setters: {
          props: meta.setters.props.map(prop => {
            if (relatedFields.has(prop.name)) {
              return {
                ...prop,
                visible: !prop.visible // 切换可见性
              };
            }
            return prop;
          }),
          layout: meta.setters.layout
        }
      };

      // 3. 验证数据结构
      if (!validateMetaStructure(newMeta)) {
        throw new Error("Invalid meta structure after visibility change");
      }

      // 4. 通知更新
      onChange?.({
        type: "setMeta",
        data: newMeta
      });

    } catch (error) {
      console.error("Visibility operation failed:", error);
    }
  };
};